
import React, { useState, useEffect } from 'react';
import Router from 'next/router';
import jwt_decode from "jwt-decode";

import { useSelector, useDispatch } from 'react-redux';

//#region JNZ Auth ======================================================

import { jnzAuthConfig } from '@root/config/config.next';
import { JnzAuthProvider, withJnzAuth, useJnzAuth } from '@root/jnzAuth';

const {
  cookiesDomain,
  jnzAuthActive,
  jnzWebToken,
  jnzAuthToken,
  jnzServiceToken,
  jnzCompanyToken,
  redirectIfNoCompany,
  redirectIfAuthenticated,
  redirectIfNotAuthenticated } = jnzAuthConfig;

//#endregion JNZ Auth ====================================================

const JNZ_AUTHEN_CALL = 'jnz_authen_call';
import { requestPingStart } from '@actions/authen';
import {
  setRolePermissionStart,
  REQUEST_ROLE_PERMISSION_SUCCESS,
  REQUEST_ROLE_PERMISSION_FAIL,
} from '@actions/role-permission';

// import {
//   DASHBOARD,
//   STORE_DASHBOARD,
//   ORDERS_MANAGEMENT,
//   ORDERS_DELIVERY,
//   ORDERS_SUB_EXPORT_DATA,
//   MASTER_CATALOG_BRAND,
//   MASTER_CATALOG_PRODUCT,
//   MASTER_CATALOG_DISPLAY_CATEGORY,
//   BRANCH_CATALOG_PRODUCT,
//   BRANCH_CATALOG_DISPLAY_COTEGORY,
//   PROMOTIONS_MANAGEMENT,
//   HOME_TEMPLATE_MANAGEMENT,
//   REPORT,
//   PERMISSION,
// } from '@root/jnzAuthWrapper/permission-keys';


//#region JNZ Auth =======================================================

export const JnzAuthWrapper = ({ Component, pageProps }) => {

  /*console.log("JnzAuthWrapper : ", { cookiesDomain, Router });*/

  // const { pathname,query } = Router?.router || {};
  // const _redirectPath=Boolean(query?.remember_me)?pathname:redirectIfNotAuthenticated;

  if (jnzAuthActive) {
    return (
      <JnzAuthProvider
        domain={cookiesDomain || 'localhost'}
        jnzAuthToken={jnzWebToken}
        jnzServiceToken={jnzServiceToken}
        jnzCompanyToken={jnzCompanyToken}
        redirectIfAuthenticated={`${Router?.router?.pathname}` || redirectIfAuthenticated}
        redirectIfNotAuthenticated={`${Router?.router?.pathname}` || redirectIfNotAuthenticated}
        redirectIfNoCompany={redirectIfNoCompany}
      >
        <CheckLogin>
          <Component {...pageProps} />
        </CheckLogin>
      </JnzAuthProvider>
    )
  }
  else
    return (<Component {...pageProps} />)
}

const CheckLogin = ({ children }) => {

  const dispatch = useDispatch();
  const appPermission = useSelector(({ rolePermission }) => rolePermission);
  const appSetting = useSelector(({ appSetting }) => appSetting);

  const [isInit, setInit] = useState(false);
  const [token, setToken] = useState(false);
  const [tokenPermission, setTokenPermission] = useState();

  useEffect(() => {

    if (!isInit) {

      // useDispatch(requestSetSystemsInfo({}));
      setInit(true)
    }

    if (isInit) {

      try {

        let _isToken = window['jnzauth']?.getAccessToken();
        const { pathname, query } = Router?.router || {};

        if (Boolean(_isToken)) {

          /*console.log("JnzAuthWrapper : ", { query, _isToken })*/

          dispatch(requestPingStart({}));
          setToken(true);

          window['jnzauth'].getPermission().then((permission) => {

            if (Boolean(permission?.permission_token))
              setTokenPermission(permission?.permission_token);
          });


        }
        else {

          async function setCallSignin() {
            await sessionStorage.setItem(JNZ_AUTHEN_CALL, true);
          }

          if (Boolean(query?.remember_me)) {

            async function fetcSigninInfo() {

              const _isCallBack = await sessionStorage.getItem(JNZ_AUTHEN_CALL) || false;

              if (_isCallBack) {

                setTimeout(() => {

                  _isToken = window['jnzauth']?.getAccessToken();

                  if (Boolean(_isToken)) {

                    window['jnzauth'].getPermission().then((permission) => {

                      if (Boolean(permission?.permission_token))
                        setTokenPermission(permission?.permission_token);
                    });

                    setToken(true);

                  }
                  else
                    window['jnzauth']?.signInWithRedirect();

                }, 450);

                setTimeout(() => { sessionStorage.removeItem(JNZ_AUTHEN_CALL); }, 500);

              }
              else {

                setCallSignin();
                window['jnzauth']?.signInWithRedirect();
              }
            }

            fetcSigninInfo();
          }
          else {

            setCallSignin();
            window['jnzauth']?.signInWithRedirect();
          }

        }

      } catch (error) { }
    }

  }, [isInit])


  useEffect(() => {

    if (isInit && Boolean(tokenPermission)) {

      // console.log("JnzAuthWrapper : 2 ", tokenPermission)

      const decoded = jwt_decode(tokenPermission);
      console.log("Role Permission : ", { decoded })
      dispatch(setRolePermissionStart(decoded));

    }

  }, [tokenPermission])

  useEffect(() => {

    if (isInit) {

      /*console.log("appSetting : ", { appSetting })*/

    }

  }, [appSetting])

  useEffect(() => {

    if (isInit) {

      /*console.log("appAuth : ", { appPermission })*/

    }

  }, [appPermission?.data?.type])


  return token ? children : null;
}



//#endregion JNZ Auth =====================================================
